export const FORGOT_PASSWORD_REQUEST_SENT = 'An email message has been sent containing a link to reset password.'
export const RESET_PASSWORD_SUCCESS = 'Your password has been restored successfully.'


// WEBPACK FOOTER //
// ./src/const/password_const.js